import React, {Component} from 'react';
import {Switch, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import {PublicRoute, LabtopRoute, MobileRoute} from './routes/WrappedRoutes';
import Login from 'Components/login/Login';
import AdminLogin from 'Components/login/AdminLogin';
import SelectCustomer from 'Components/order/SelectCustomer';
import Demo from './demo/index';
import ProductList from 'Components/order/ProductList';
import ProductSearchPage from 'Components/order/ProductSearchPage';
import UserCenter from 'Components/userCenter/UserCenter';
import UserCenterInfor from 'Components/userCenter/UserCenterInfor';
import MyOrderList from 'Components/userCenter/MyOrderList';
import MyOrderSearch from 'Components/userCenter/MyOrderSearch';
import MyOrderDetail from 'Components/userCenter/MyOrderDetail';
import Feedback from 'Components/userCenter/Feedback';
import OrderReport from 'Components/userCenter/OrderReport';
import ShipmentList from 'Components/host/ShipmentList';
import ShipmentDetails from 'Components/host/ShipmentDetails';
import DeliverDetails from 'Components/host/DeliverDetails';
import HostShipmentDetails from 'Components/host/HostShipmentDetails';
import ShipEdit from 'Components/host/ShipEdit';
import F1OrderList from 'Components/host/F1OrderList';
import F1OrderSearchList from 'Components/host/F1OrderSearchList';
// import F1OrderDetails2 from 'Components/host/F1OrderDetails';
import F1OrderReceive from 'Components/host/F1OrderReceive';
import F1OrderReceiveManagement from 'Components/host/F1OrderReceiveManagement';
import F1OrderDetailPage from 'Components/host/F1OrderDetailPage';
import F1PackageReceive from 'Components/host/F1PackageReceive';
import F1OrderOnTheGoPackageReceive from 'Components/host/F1OrderOnTheGoPackageReceive';
import AbnormalRecordList from 'Components/host/AbnormalRecordList';
import AbnormalRecordSave from 'Components/host/AbnormalRecordSave';
import CustomerFeedBack from 'Components/host/CustomerFeedBack';
import Notification from 'Components/common/Notification';
import ShoppingCart from 'Components/order/ShoppingCart';
import OrderConfirmation from 'Components/order/OrderConfirmation';
import OrderSuccess from 'Components/order/OrderSuccess';
import ReplenishmentManagement from 'Components/replenishment/ReplenishmentManagement';
import ReplenishmentSCDetails from 'Components/replenishment/ReplenishmentSCDetails';
import ReplenishmentCart from 'Components/replenishment/ReplenishmentCart';
import AdminF1OrderList from 'Components/replenishment/AdminF1OrderList';
import AdminF1OrderDetails from 'Components/replenishment/AdminF1OrderDetails';
import ShippedF1OrderDetails from 'Components/replenishment/ShippedF1OrderDetails';
import ReplenishmentProductDetails from 'Components/replenishment/ReplenishmentProductDetails';
import ReplenishmentProductDetailsCard from 'Components/replenishment/ReplenishmentProductDetailsCard';
import BackupList from 'Components/userCenter/BackupList';
import RequestBackup from 'Components/userCenter/RequestBackup';

import PackageDetails from 'Components/commonOrder/PackageDetails';
import SyncST from 'Components/userCenter/SyncST';
import Language from 'Components/userCenter/Language';

import TaskManagementList from 'Components/host/taskManagement/TaskManagementList';
import TaskDetails from 'Components/host/taskManagement/TaskDetails';
import CustomerForTaskAssignment from 'Components/host/taskManagement/CustomerForTaskAssignment';

import InventoryQuery from 'Components/inventoryQuery/InventoryQuery';
import InventoryQueryDetails from 'Components/inventoryQuery/InventoryQueryDetails';
import AdventProductsSCList from 'Components/host/AdventProductsSCList';
import AdventProductDetails from 'Components/host/AdventProductDetails';
import InternalTransferOrderList from 'Components/host/InternalTransferOrderList';
import InternalTransferOrderDetail from 'Components/host/InternalTransferOrderDetail';
import AddTransferOrder from 'Components/host/AddTransferOrder';
import ApplyForListing from 'Components/applyForListing/ApplyForListing';
import MessageList from 'Components/host/MessageList';
import YourMessage from 'Components/host/YourMessage';
import StManagementList from 'Components/stManagement/StManagementList';
import StApplyChange from 'Components/stManagement/StApplyChange';
import AllApplyList from 'Components/allApply/allApplyList';
import AllApplyApprovalDetails from 'Components/allApply/allApplyApprovalDetails';
import DemoSiteOrderList from 'Components/order/DemoSiteOrderList';
import ClockedSigned from 'Components/host/ClockedSigned';

import MyOrderPick from 'Components/pickList/MyOrderPick';

import LtoHistoryList from 'Components/lto/orderHistory/LtoHistoryList';
import LtoPurchaesOrderHistoryDetails from 'Components/lto/orderHistory/LtoPurchaesOrderHistoryDetails';
import PurchaseOrderSelectCustomer from 'Components/lto/order/SelectCustomer';
import PurchaseOrderProductList from 'Components/lto/order/ProductList';
import PurchaseOrderShoppingCart from 'Components/lto/order/ShoppingCart';
import PurchaseOrderOrderConfirmation from 'Components/lto/order/OrderConfirmation';
import PurchaseDemoSiteOrderList from 'Components/lto/order/DemoSiteOrderList';
import PurchaseOrderSuccess from 'Components/lto/order/OrderSuccess';
import PurchaseProductSearchPage from 'Components/lto/order/ProductSearchPage';

import ProxyDeliveryOrderList from 'Components/host/proxyDeliveryManagement/ProxyDeliveryOrderList';
import ProxyDeliveryForPackageReceive from 'Components/host/proxyDeliveryManagement/ProxyDeliveryForPackageReceive';

// add the public route here.
const publicRoutes = [
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/demo',
        component: Demo,
    },
    {
        path: '/adminLogin',
        component: AdminLogin,
    },
    {
        path: '/productList',
        component: ProductList,
    },

    {
        path: '/productSearchPage',
        component: ProductSearchPage,
    },
    {
        path: '/userCenter',
        component: UserCenter,
    },
    {
        path: '/userCenterInfor',
        component: UserCenterInfor,
    },
    {
        path: '/feedback',
        component: Feedback,
    },
    {
        path: '/orderReport',
        component: OrderReport,
    },
    {
        path: '/myOrderList/unreceived',
        component: MyOrderList,
    },
    {
        path: '/myOrderList/received',
        component: MyOrderList,
    },
    {
        path: '/myOrderList/canceled',
        component: MyOrderList,
    },
    {
        path: '/myOrderSearch',
        component: MyOrderSearch,
    },
    {
        path: '/myOrderDetail/:id',
        component: MyOrderDetail,
    },
    {
        path: '/shoppingCart',
        component: ShoppingCart,
    },
    {
        path: '/testShoppingCart',
        component: ShoppingCart,
    },
    {
        path: '/orderConfirmation',
        component: OrderConfirmation,
    },
    {
        path: '/orderSuccess',
        component: OrderSuccess,
    },
    {
        path: '/shipmentList/:tab',
        component: ShipmentList,
    },
    {
        path: '/shipmentDetails',
        component: ShipmentDetails,
    },
    {
        path: '/deliverDetails',
        component: DeliverDetails,
    },
    {
        path: '/hostShipmentDetails',
        component: HostShipmentDetails,
    },
    {
        path: '/shipEdit/:id',
        component: ShipEdit,
    },
    {
        path: '/F1OrderList',
        component: F1OrderList,
    },
    {
        path: '/F1OrderSearchList',
        component: F1OrderSearchList,
    },
    {
        path: '/internalTransferOrderDetail/:id',
        component: InternalTransferOrderDetail,
    },
    {
        path: '/F1OrderReceive/:id',
        component: F1OrderReceive,
    },
    {
        path: '/F1OrderReceiveManagement/:id',
        component: F1OrderReceiveManagement,
    },
    {
        path: '/F1OrderDetailPage/:id',
        component: F1OrderDetailPage,
    },
    {
        path: '/F1PackageReceive',
        component: F1PackageReceive,
    },
    {
        path: '/F1OrderOnTheGoPackageReceive',
        component: F1OrderOnTheGoPackageReceive,
    },
    {
        path: '/host/taskManagementList',
        component: TaskManagementList,
    },
    {
        path: '/host/taskDetails',
        component: TaskDetails,
    },
    {
        path: '/host/customerForTaskAssignment',
        component: CustomerForTaskAssignment,
    },
    {
        path: '/inventoryQuery',
        component: InventoryQuery,
    },
    {
        path: '/inventoryQueryDetails',
        component: InventoryQueryDetails,
    },
    {
        path: '/replenishmentMgmt',
        component: ReplenishmentManagement,
    },
    {
        path: '/replenishmentSCDetails',
        component: ReplenishmentSCDetails,
    },
    {
        path: '/replenishmentCart',
        component: ReplenishmentCart,
    },
    {
        path: '/adminF1OrderList',
        component: AdminF1OrderList,
    },
    {
        path: '/adminF1OrderDetails',
        component: AdminF1OrderDetails,
    },
    {
        path: '/shippedF1OrderDetails',
        component: ShippedF1OrderDetails,
    },
    {
        path: '/replenishmentProductDetails',
        component: ReplenishmentProductDetails,
    },
    {
        path: '/replenishmentProductDetailsCard',
        component: ReplenishmentProductDetailsCard,
    },
    {
        path: '/abnormalRecordList',
        component: AbnormalRecordList,
    },
    {
        path: '/abnormalRecordSave',
        component: AbnormalRecordSave,
    },
    {
        path: '/AdventProductsSCList',
        component: AdventProductsSCList,
    },
    {
        path: '/AdventProductDetails',
        component: AdventProductDetails,
    },
    {
        path: '/selectCustomer',
        component: SelectCustomer,
    },
    {
        path: '/backupList',
        component: BackupList,
    },
    {
        path: '/requestBackup',
        component: RequestBackup,
    },
    {
        path: '/packageDetail/:id',
        component: PackageDetails,
    },
    {
        path: '/syncST',
        component: SyncST,
    },
    {
        path: '/language',
        component: Language,
    },
    {
        path: '/internalTransferOrderList',
        component: InternalTransferOrderList,
    },
    {
        path: '/addTransferOrder',
        component: AddTransferOrder,
    },
    {
        path: '/applyForListing',
        component: ApplyForListing,
    },
    {
        path: '/messageList',
        component: MessageList,
    },
    {
        path: '/yourMessage',
        component: YourMessage,
    },
    {
        path: '/stManagementList',
        component: StManagementList,
    },
    {
        path: '/stApplyChange',
        component: StApplyChange,
    },
    {
        path: '/allApplyList',
        component: AllApplyList,
    },
    {
        path: '/allApplyApprovalDetails/:id',
        component: AllApplyApprovalDetails,
    },
    {
        path: '/demoSiteOrderList',
        component: DemoSiteOrderList,
    },
    {
        path: '/myOrderPick',
        component: MyOrderPick,
    },
    {
        path: '/clockedSigned',
        component: ClockedSigned,
    },
    {
        path: '/customerFeedBack',
        component: CustomerFeedBack,
    },

    //Purchaes Order
    {
        path: '/purchase/ltoHistoryList',
        component: LtoHistoryList,
    },
    {
        path: '/ltoPurchaesOrderHistoryDetails',
        component: LtoPurchaesOrderHistoryDetails,
    },
    {
        path: '/purchase/selectCustomer',
        component: PurchaseOrderSelectCustomer,
    },
    {
        path: '/purchase/productList',
        component: PurchaseOrderProductList,
    },
    {
        path: '/purchase/shoppingCart',
        component: PurchaseOrderShoppingCart,
    },
    {
        path: '/purchase/orderConfirmation',
        component: PurchaseOrderOrderConfirmation,
    },
    {
        path: '/purchase/notSupplyCenter',
        component: PurchaseDemoSiteOrderList,
    },
    {
        path: '/purchase/orderSuccess',
        component: PurchaseOrderSuccess,
    },
    {
        path: '/myOrderDetail', //从预购单的客户已确认 到订单详情
        component: MyOrderDetail,
    },
    {
        path: '/purchase/sso',
        component: AdminLogin,
    },
    {
        path: '/purchase/productSearchPage',
        component: PurchaseProductSearchPage,
    },
    {
        path: '/proxyDeliveryOrderList',
        component: ProxyDeliveryOrderList,
    },
    {
        path: '/proxyDeliveryForPackageReceive',
        component: ProxyDeliveryForPackageReceive,
    },
];

const mobileRoutes = [];

const labtopRoutes = [
    {
        path: '/testProductList/:id',
        component: ProductList,
    },
];

class App extends Component {
    componentDidMount() {}

    getRedirecRoute() {
        let redirecRoute = '/adminLogin';
        var route = window.location.href;
        const hasTargetURL = route.includes('/purchase/sso');
        if (hasTargetURL) {
            redirecRoute = '/purchase/sso';
        } else {
            redirecRoute = '/adminLogin';
        }
        return redirecRoute;
    }

    render() {
        const {isAuthenticated} = this.props;
        return (
            <div>
                <Router>
                    <Switch>
                        {publicRoutes.map((route, i) => {
                            return (
                                <PublicRoute
                                    key={`public_route_${i}`}
                                    {...route}
                                />
                            );
                        })}
                        {mobileRoutes.map((route, i) => {
                            return (
                                <MobileRoute
                                    key={`mobile_route_${i}`}
                                    {...route}
                                    routes={route.path}
                                    isAuthenticated={isAuthenticated}
                                />
                            );
                        })}
                        {process.env.http_env !== 'prod'
                            ? labtopRoutes.map((route, i) => {
                                  return (
                                      <LabtopRoute
                                          key={`labtop_route_${i}`}
                                          {...route}
                                          routes={route.path}
                                          isAuthenticated={isAuthenticated}
                                      />
                                  );
                              })
                            : null}
                        <Redirect to={{pathname: this.getRedirecRoute()}} />
                        {/* <Redirect to={{pathname: '/adminLogin'}} /> */}
                    </Switch>
                </Router>
                <Notification></Notification>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {auth} = state;
    return {
        isAuthenticated: auth.isAuthenticated,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);
